// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_friday = /** @type {(inputs: {}) => string} */ () => {
	return `Friday`
};

const el_friday = /** @type {(inputs: {}) => string} */ () => {
	return `Παρασκευή`
};

const ru_friday = /** @type {(inputs: {}) => string} */ () => {
	return `Пятница`
};

const he_friday = /** @type {(inputs: {}) => string} */ () => {
	return `יום שישי`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const friday = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.friday(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("friday", locale)
	if (locale === "en") return en_friday(inputs)
	if (locale === "el") return el_friday(inputs)
	if (locale === "ru") return ru_friday(inputs)
	if (locale === "he") return he_friday(inputs)
	return "friday"
};